<template>
    <div class="main">
        <router-link to="/purchase-order-menu" style="font-size:14px;text-decoration:none;line-height:30px;color:#98c14b;display:flex">
            <p>
                <a-icon type="double-left" />
            </p> 
            <p>Go Back</p>
            
        </router-link >
        <div>
            <h3 style="font-size:28px;line-height:45px"> Replenish </h3>
        </div>
        <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">
            <a-button @click="replenishAll" :loading="loading" :disabled="!hasSelected" :class="[ hasSelected ? 'activeBtn' : 'disbablesBtn' ]">
                Replenish
            </a-button>
            <!-- <a-button @click="exportExcell" style="height:38px;border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                Export
            </a-button> -->
        </div>
        
        <div>
                <a-table
                :columns="columns"
                :data-source="tableReplenishProducts"
                :loading='tableLoading'
                :pagination="pagination"
                :row-selection="rowSelection"
                class="customerTable"
                >
                    <template slot="action" slot-scope="data">    
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item >
                                    <a @click="replenishProduct(data)">Replenish Product?</a>
                                </a-menu-item>
                                
                            </a-menu>
                        </a-dropdown>
                    </template>

                    <template slot="status" slot-scope="data">
                        <status-component v-if="data" :status="data"></status-component>
                    </template>
                </a-table>
          </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
const columns = [
{
    title: "Product ID",
    width: 90,
    dataIndex: 'productId',
    key: 'productId'
  },
  {
    title: 'Product Name',
    dataIndex: 'productBrandName',
    width: 100,
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    width: 100,
  },
  {
    title: 'Supplier Name',
    dataIndex: 'supplierName',
    width: 100,
  },
  {
    title: 'Purchase Price',
    dataIndex: 'purchasePrice',
    width: 100,
  },
  
  {
    title: 'Category Name',
    dataIndex: 'categoryName',
    width: 100,
  },
  {
    title: 'Total Sale Value',
    dataIndex: 'totalSaleValue',
    width: 100,
  },
  {
    title: 'Total Purchase Value',
    dataIndex: 'totalPurchaseValue',
    width: 100,
  },

  
//   {
//     title: 'Created At',
//     dataIndex: 'createdAt',
//     // width: 130,
//   },
 
//   {
//     title: 'Status',
//     dataIndex: 'status',
//     // width: 150,
//     scopedSlots: { customRender: 'status' }
//   },
 
//   {
//     title: 'Action',
//     dataIndex: 'action',
//     width: 100,
//     scopedSlots: { customRender: 'action' }
//   }
];


    export default {
        name: 'ReplenishProducts',
        data(){
            return {
                columns,
                tableReplenishProducts:[],
                tableLoading: false,
                loading: false,
                pagination: {
                    pageSize:5
                },
                selectedRowKeys: [],
                selectedRows: []
            }
        },
        computed:{
            ...mapGetters(['getReplenishData']),
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
            rowSelection() {
                const { selectedRowKeys } = this;
                return {
                    selectedRowKeys,
                    onChange: this.onSelectChange,
                    hideDefaultSelections: true,
                    selections: [
                        {
                            key: 'all-data',
                            text: 'Select All Produts',
                            onSelect: () => {
                                this.selectedRowKeys = this.tableReplenishProducts.map(order => order.key); 
                                this.selectedRows = this.tableReplenishProducts
                            },
                        },
                        {
                            key: 'unselect-data',
                            text: 'Deselect All Produts',
                            onSelect: () => {
                                this.selectedRowKeys = []; 
                                this.selectedRows = []
                            },
                        },
                    ],
                }
            },
            
        },
        methods:{
            ...mapActions(['setPreviewInfo','setReplenishDataInfo']),
            // replenishProduct(data){
            //     console.log("data | ", data)
            // },
            onSelectChange(selectedRowKeys, selectedRows) {
                // console.log('selectedRowKeys changed: ', selectedRowKeys);
                // console.log('selectedRows changed: ', selectedRows);
                this.selectedRows = selectedRows
                this.selectedRowKeys = selectedRowKeys;
            },
            replenishAll(){
                // console.log('selectedRows: ', this.selectedRows[0]);
                // console.log('selectedRowKeys: ', this.selectedRowKeys);
                this.loading = true;
                // ajax request after empty completing
                const result = JSON.parse(this.getReplenishData)
                const data = {
                    ...result,
                    selectedOrdera: this.selectedRows
                }

                this.setReplenishDataInfo(JSON.stringify(data))
                const purchaseOrders = this.selectedRows.map(order => ({
                    key: order.productId,
                    productId: order.productId,
                    name: order.productBrandName,
                    category: order.categoryName ? order.categoryName : "",
                    quantity: order.quantity.toString(),
                    unitPrice: order.purchasePrice.toString(),
                    lineTotal: parseInt(order.quantity) * parseFloat(order.purchasePrice)
                }))
                
                let previewData = { 
                    discount: '',
                    deliveryDate: '',
                    supplierName: result.supplier.name,
                    supplierId: result.supplier.id,
                    supplierAddress: result.supplier.address,
                    supplierCity: '',
                    supplierCountry: '',
                    destionation: '',
                    sellerAddress: '',
                    shipCity: '',
                    shipCountry:'',
                    shippingMethod: '',
                    shippinTerm: '',
                    tableData: purchaseOrders,
                    statusLabel: '',
                    action:"add",
                    deleiveries:[]
                }
                // console.log("previewData | ", previewData)
                this.setPreviewInfo(JSON.stringify(previewData));  
                this.$router.push('/purchase-order-edit').catch(()=>{});
                this.loading = false;
                this.selectedRowKeys = [];
                this.selectedRows = []
            },
            loadReplenishData(){
                const result = JSON.parse(this.getReplenishData)
                this.tableReplenishProducts = result.replenisedOrder.map(order => ({
                    key: order.productId,
                    productId: order.productId,
                    productBrandName: order.productBrandName,
                    quantity: order.quantity,
                    supplierName: order.supplierName,
                    purchasePrice: order.purchasePrice,
                    categoryName: order.categoryName,
                    totalSaleValue: order.totalSaleValue,
                    totalPurchaseValue: order.totalPurchaseValue
                }))
            }
            
        },
        created(){
            if(this.loadReplenishData){
                this.loadReplenishData()
            }
        }
    }
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.customerTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.customerTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.customerTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.customerTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
.disbablesBtn{
    color: rgba(0,0,0,.25);
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    text-shadow: none;
    box-shadow: none;
    height:38px;
     border-raduis:5px; 
}
.activeBtn{
    height:38px;
    margin-right: 10px;
    border-raduis:5px; 
    background: #418a49; 
    color:#fff;
}
</style>